export const chartTheme = {
  colors: {
    axis: '#6b7280',       // gray-500
    grid: '#e5e7eb',       // gray-200
    label: '#111827',      // gray-900
    bar: '#2563eb',        // blue-600
    line: '#16a34a',       // green-600
    dot: '#16a34a',
    donut: {
      POS: '#2563eb',                 // blue-600
      DIRECT: '#16a34a',              // green-600
      CONVERTED_QUOTE: '#f59e0b',     // amber-500
      CUSTOMER_ORDER: '#ef4444',      // red-500
      RECURRING_PROFORMA: '#a855f7',  // purple-500
      QUOTE_ADVANCE: '#06b6d4',       // cyan-500
      OTHER: '#9ca3af'                // gray-400
    }
  },
  fonts: {
    labelSize: 10,
    tickSize: 10
  },
  layout: {
    pad: 32,
    yTicks: 4
  }
};


